export interface IDeviceProperties {
    id: string;
    name: string;
    unit: string;
    isSelected: boolean;
    shortProperty: string;
    index: number;
    uniqueId: string;
}
export class DeviceProperties implements IDeviceProperties {
    constructor(id: string, name: string, unit: string, isSelected: boolean, index: number, uniqueId: string) {
        this.id = id;
        this.name = name;
        this.unit = unit;
        this.isSelected = isSelected;
        this.index = index;
        this.shortProperty = this.name;
        this.uniqueId = uniqueId;
    }
    shortProperty: string;
    id: string;
    name: string;
    unit: string;
    isSelected: boolean;
    index: number;
    uniqueId: string;
}
